<script>
import {
  CHANGE_STATUS_SCHOOL,
  DELETE_SCHOOL, DETAIL_SCHOOL,
  GET_LIST_SCHOOL
} from "@/core/services/store/school-link-source/school-link-source.module";
import {StatusSchool} from "@/core/option/schoolLinkSource";
import {GET_PROVINCES} from "@/core/services/store/public/provinces.module";
import ModalAddSchool from "@/view/pages/school-link-source/component/ModalAddSchool.vue";
import ModalEditSchool from "@/view/pages/school-link-source/component/ModalEditSchool.vue";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {EXPORT_LIST_SCHOOL} from "../../../core/services/store/school-link-source/school-link-source.module";
import {exportExcel} from "../../../core/filters";
import {DisplaySchool} from "../../../core/option/schoolLinkSource";
import {SchoolLinkModel} from "@/view/pages/school-link-source/model/schoolLinkModel";


export default {
  name: "ListSchool",
  components: {ModalEditSchool, ModalAddSchool},
  data() {
    return {
      listSchool: [],
      operate: 1,
      shutDown: 0,
      page: 1,
      last_page: 0,
      total: 0,
      nameSchool: null,
      provinceId: null,
      status: null,
      statusSchool: StatusSchool,
      provinces: [],
      loading: false,
      idSchool:null,
      schoolCurrent: null,
      exportLoading: false,
      displaySchoolOption: DisplaySchool,
      action: null
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Danh sách trường"},
    ]);
    this.applyQueryFilters();
    this.getListSchool();
    this.getProvinces()
  },
  methods: {
    normalizeQueryNumber(value) {
      if (value === undefined || value === null || value === '') {
        return null;
      }

      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? null : numberValue;
    },
    applyQueryFilters() {
      const query = this.$route.query;

      this.nameSchool = query.name ?? null;
      this.provinceId = this.normalizeQueryNumber(query.province_id);
      this.status = this.normalizeQueryNumber(query.status);
      this.action = this.normalizeQueryNumber(query.action);
      this.page = this.normalizeQueryNumber(query.page) || 1;
    },
    buildRouteQuery(page = this.page) {
      const query = {
        name: this.nameSchool || undefined,
        province_id: this.provinceId ?? undefined,
        status: this.status ?? undefined,
        action: this.action ?? undefined,
        page: page > 1 ? page : undefined,
      };

      return Object.keys(query).reduce((result, key) => {
        if (query[key] !== undefined && query[key] !== null && query[key] !== '') {
          result[key] = query[key];
        }

        return result;
      }, {});
    },
    syncRouteQuery(page = this.page) {
      const query = this.buildRouteQuery(page);

      if (JSON.stringify(query) === JSON.stringify(this.$route.query)) {
        return;
      }

      this.$router.push({query}).catch(() => {});
    },
    getListSchool(isSearch = false) {
      this.loading = true;
      if (isSearch) {
        this.page = 1;
      }
      const payload = {
        name: this.nameSchool,
        province_id: this.provinceId,
        status: this.status,
        action: this.action,
        page: this.page
      }
      this.$store.dispatch(GET_LIST_SCHOOL, payload).then((res) => {
        this.listSchool = res?.data.map((school) => new SchoolLinkModel(school))
        this.total = res.pagination.total;
        this.page = res.pagination.current_page;
        this.last_page = res.pagination.last_page;
      }).finally(() => {
        this.loading = false;
      })
    },
    clickCallback(obj) {
      this.page = obj;
      this.syncRouteQuery(this.page);
      this.getListSchool();
    },
    searchSchool() {
      this.page = 1;
      this.syncRouteQuery(this.page);
      this.getListSchool(true);
    },
    getProvinces() {
      this.$store.dispatch(GET_PROVINCES).then((res) => {
        if (!res.error) {
          this.provinces = res.data;
        }
      });
    },
    openAddSchool() {
      this.$bvModal.show("Modal_Add_School")
    },
    async openEditSchool(school) {
      this.getDetailSchool(school.idSchool);
    },
    deleteSchool(nameSchool, id) {
      this.$confirm(`Bạn có chắc chắn muốn xóa trường ${nameSchool} không?`, 'Xoá trường', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy',
      }).then(() => {
        this.$store.dispatch(DELETE_SCHOOL, id).then((data) => {
          if (!data.error) {
            this.$notify({
              title: 'Thành công',
              message: 'Xóa trường liên kết thành công',
              type: 'success'
            });
            this.getListSchool()
          } else {
            this.$notify.error({
              title: 'Đã có lỗi xẩy ra',
              message: `${data.message}`
            });
          }

        }).catch((e) => {
          this.$notify.error({
            title: 'Đã có lỗi xẩy ra',
            message: `${e.message}`
          });
        })
      }).catch(() => {
      });
    },
    changeStatusSchool(nameSchool, id, school){
      this.$confirm(`Bạn có chắc chắn muốn ${school.changeStatusTitle} trường ${nameSchool} không?`, `${school.changeStatusTitle} trường`, {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy',
      }).then(() => {
        let payload = {
          id: id,
          status: school.nextStatusValue
        }
        this.$store.dispatch(CHANGE_STATUS_SCHOOL, payload).then((data) => {
          if (!data.error) {
            this.$notify({
              title: 'Thành công',
              message: `${school.changeStatusTitle} trường thành công`,
              type: 'success'
            });
            this.getListSchool()
          } else {
            this.$notify.error({
              title: 'Đã có lỗi xẩy ra',
              message: `${data.message}`
            });
          }

        }).catch((e) => {
          this.$notify.error({
            title: 'Đã có lỗi xẩy ra',
            message: `${e.message}`
          });
        })
      }).catch(() => {
      });
    },
    getDetailSchool(id){
      this.$store.dispatch(DETAIL_SCHOOL,id).then((data)=>{
        this.schoolCurrent = data.data;
        setTimeout(()=>{
          this.$bvModal.show("Modal_Edit_School");
        },600)

      })
    },
    async exportExcelSchool(){
      const payload = {
        name: this.nameSchool,
        province_id: this.provinceId,
        status: this.status,
        action: this.action,
      }
      try{
        this.exportLoading = true
        const res = await this.$store.dispatch(EXPORT_LIST_SCHOOL, payload)
        const HEADER_ROW_EXPORT_SCHOOL = [
          {
            key: 'id',
            value: 'Mã trường',
          },
          {
            key: 'name',
            value: 'Tên trường',
          },
          {
            key: 'province',
            value: 'Khu vực',
          },
          {
            key: 'business_coefficient',
            value: 'Hệ số đội kinh doanh',
          },
          {
            key: 'school_rate',
            value: 'Phần trăm nhà trường',
          },
          {
            key: 'source',
            value: 'Nguồn trích % nhà trường',
          },
          {
            key: 'status',
            value: 'Trạng thái',
          },
        ]
        exportExcel(HEADER_ROW_EXPORT_SCHOOL, res.data, "Quản lý trường liên kết.xlsx", false)
      }catch (e) {
        this.$notify.error({
          title: 'lỗi',
          message: 'Không thể xuất file, vui lòng thử lại sau'
        });
      }finally {
        this.exportLoading = false
      }

    }
  },

}
</script>

<template>
  <div class="card card-custom gutter-b h-100">
    <!--    header-->
    <div class="card-header">
      <div class="card-title">
        Danh sách trường
      </div>
      <div class="card-title">
        <button class="button-75 mr-4"
                style="background-color: #0066FF;color: white;min-width:94px;padding: 5px ;border-radius: 5px" @click="exportExcelSchool()" :disabled="exportLoading">
          <i v-if="exportLoading" class="el-icon-loading"></i>
          <span>Xuất excel</span>
        </button>
        <button class="button-75"
                style="background-color: #1BC5BD;color: white;min-width:120px;padding: 5px ;border-radius: 5px"
                @click="openAddSchool()">
          <span>Thêm trường</span>
        </button>
      </div>
    </div>
    <!--    body-->
    <div class="card-body">
      <div class="row">
        <div class="col-md-2 col-sm-12 mb-3">
          <h4 style="font-size: 13px">Trường</h4>
          <el-input placeholder="Nhập tên, mã trường" v-model="nameSchool"></el-input>
        </div>
        <div class="col-md-2 col-sm-12 mb-3">
          <h4 style="font-size: 13px">Tỉnh</h4>
          <el-select v-model="provinceId" placeholder="Tỉnh" clearable filterable>
            <el-option
                v-for="item in provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-2 col-sm-12 mb-3">
          <h4 style="font-size: 13px">Trạng thái</h4>
          <el-select v-model="status" placeholder="Trạng thái" clearable>
            <el-option
                v-for="item in statusSchool"
                :key="item.value"
                :label="item.name"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-2 col-sm-12 mb-3">
          <h4 style="font-size: 13px">Hiển thị</h4>
          <el-select v-model="action" placeholder="Hiển thị" clearable>
            <el-option
                v-for="item in displaySchoolOption"
                :key="item.value"
                :label="item.name"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-2 col-sm-12 mb-3">
          <button class="button-75 mr-4"
                  style="background-color: #0066FF;color: white;min-width:94px;padding: 5px ;border-radius: 5px;height: 38px;margin-top:22px"
                  @click="searchSchool">
            <span>Tìm kiếm</span>
          </button>
        </div>
      </div>
      <!--      table-->
      <div class="mt-10 table-responsive b-table-sticky-header" style="height: 480px">
        <table class="table table-bordered  table-vertical-center b-table ">
          <thead class="thead-light">
          <tr style="background-color: #F8F8F8 ; font-size: 13px">
            <th>Mã trường</th>
            <th>Tên trường</th>
            <th>Tỉnh</th>
            <th>Trạng thái</th>
            <th>Hiển thị</th>
            <th>Loại trường</th>
            <th>Phân loại</th>
            <th style="text-align: center; width: 115px">Hành động</th>
          </tr>
          </thead>
          <tbody v-if="loading">
          <tr>
            <td colspan="9" class="text-center">
              <div>
                <span style="display: block">Đang tải ...</span>
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-else-if="listSchool.length === 0">
          <tr>
            <td colspan="9" class="text-center">
              <div>
                Không có dữ liệu.
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-else-if="listSchool.length !== 0">
          <tr v-for="(school,index) in listSchool" :key="index">
            <td>
              {{ school.idSchool }}
            </td>
            <td>
              {{ school.nameSchool }}
            </td>
            <td>
              {{ school.provinceName }}
            </td>
            <td>
              <span :class="school.statusClass" style="font-size: 13px; white-space: nowrap">{{ school.statusName }}</span>
            </td>
            <td>
              <span v-if="school.displayName" :class="school.displayClass" style="font-size: 13px; white-space: nowrap">{{ school.displayName }}</span>
            </td>
            <td>{{ school.schoolTypeName }}</td>
            <td>{{ school.classificationName }}</td>
            <td class="text-center">
              <el-tooltip effect="dark" placement="top" content="Sửa">
                <button class="btn btn-xs btn-icon mr-2 btn-outline-warning" @click="openEditSchool(school)">
                  <i class="flaticon2-pen" ></i>
                </button>
              </el-tooltip>
              <el-tooltip effect="dark" placement="top" :content="school.changeStatusTitle">
                <button
                    class="btn btn-xs btn-icon mr-2"
                    :title="school.changeStatusTitle"
                    :class="{'stop_linking':school.isLinked,'linking':school.canLink}"
                    @click="changeStatusSchool(school.nameSchool,school.idSchool,school)"
                >
                  <img v-if="school.canLink" src="../../../assets/img/link.png" alt="">
                  <img v-if="school.isLinked" src="../../../assets/img/un-link.png" alt="">
                </button>
              </el-tooltip>
              <el-tooltip effect="dark" placement="top" content="Xóa">
                <button
                    class="btn btn-xs btn-icon mr-2 btn-outline-danger "
                    @click="deleteSchool(school.nameSchool,school.idSchool)"
                >
                  <i class="fas fa-trash" ></i>
                </button>
              </el-tooltip>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mb-0 d-flex flex-row-reverse mr-10">
      <p class="mb-0">Tổng số bản ghi: <span class="text-primary ">{{ total }}</span></p>
    </div>
    <div class="edu-paginate mx-auto text-center mt-10 ">
      <paginate
          v-model="page"
          :page-count="last_page"
          :page-range="3"
          :margin-pages="1"
          :click-handler="clickCallback"
          :prev-text="'Trước'"
          :next-text="'Sau'"
          :container-class="'pagination b-pagination'"
          :pageLinkClass="'page-link'"
          :next-link-class="'next-link-item'"
          :prev-link-class="'prev-link-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
          :page-class="'page-item'"
      >
      </paginate>
    </div>
    <modal-add-school :provinces="provinces" @refreshData="getListSchool"></modal-add-school>
    <modal-edit-school :provinces="provinces" @refreshData="getListSchool" :schoolCurrent = "schoolCurrent"></modal-edit-school>
  </div>
</template>

<style scoped>
.stop_linking{
  border-color: #001A72;

}
.stop_linking:hover,
.stop_linking:focus {
  border-color: #001A72!important;
}
.linking{
  border-color: #309AF7;
}
.linking:hover,
.linking:focus {
  border-color: #309AF7!important;
}

.status-success {
  background: #00800D;
  padding: 5px;
  border-radius: 4px;
  color: white;
  font-size: 13px;
}
.status-error {
  background: #6F6F6F;
  padding: 5px;
  border-radius: 4px;
  color: white;
  font-size: 13px;
}
.status-not-linked {
  background: #FAD200;
  padding: 5px;
  border-radius: 4px;
  color: black;
  font-size: 13px;
}
.display-status-visible {
  background: #02CB83;
  padding: 5px;
  border-radius: 4px;
  color: white;
  font-size: 13px;
}
.display-status-hidden {
  background: #C5C6CA;
  padding: 5px;
  border-radius: 4px;
  color: black;
  font-size: 13px;
}

.button-75 span {
  font-size: 14px;
  cursor: pointer;
  transition: font-size 1s;
}

.button-75:hover span {
  font-size: 12px;
  opacity: .75;
}
</style>
